module.exports = __webpack_public_path__ + "img/logo-new-lite.7a815fb6.png";